var exports = {
  "kL": "container__GZ-7kW",
  "Oy": "pageControls__0BbB93",
  "KK": "viewSwitch__1XPWWV",
  "ne": "controls__tXNFpA",
  "wr": "filterIndicator__gOwyiO",
  "k3": "sortNoticeAnchor__1TZB7O",
  "V8": "sortNotice__U2Vcb-",
};

module.exports = exports;
